<template>
  <div class="sp_step">
    <el-form :model="registerTwoForm"
             :rules="registerTwoRules"
             ref="registerTwoForm"
             @submit.native.prevent>
      <el-form-item :label="$t('loginModule.checkCode')+'：'"
                    prop="code">
        <el-input v-model="registerTwoForm.code"
                  type="text"></el-input>
      </el-form-item>
      <el-form-item>
        <div style="display:flex; justify-content: space-between; align-items: center; padding-bottom:10px;">
          <p>{{$t("loginModule.noCode")}}</p>
          <el-button :disabled="timeOut>0"
                     @click="sendCode"
                     size="small"
                     plain>{{timeOut>0?timeOut+'s':$t("loginModule.sendAgain")}}</el-button>
        </div>
        <el-button :loading="checkLoading"
                   type="primary"
                   style="width:100%;height:48px; font-size:16px;"
                   @click="checkVerificationCode('registerTwoForm')">{{$t('loginModule.check')}}</el-button>
        <p class="sp_register_skip">{{$t("loginModule.haveAccount")}}&nbsp;<router-link :to="{path:'/login'}">{{$t("loginModule.login")}}</router-link>
        </p>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { checkRegisterEmail, sendRegisterEmail } from '@/api/loginApi.js'
import { registerEncrypt } from '@/utils/encrypt.js'
export default {
  components: {},
  name: 'registerTwo',
  props: {
    registertowParams: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      registerTwoForm: {
        code: '',
      },

      registerTwoRules: {
        code: [
          {
            required: true,
            message: 'Please input Verification Code.',
            trigger: 'blur',
          },
        ],
      },
      timeOut: 59,
      checkLoading: false,
    }
  },

  methods: {
    //倒计时
    countDown() {
      const timeNum = 59
      let timer = setInterval(() => {
        if (this.timeOut > 0 && this.timeOut <= timeNum) {
          this.timeOut--
          this.$ls.set('reTimeOut', this.timeOut)
        } else {
          clearInterval(timer)
          this.timer = null
        }
      }, 1000)
    },

    //发送验证码
    sendCode() {
      let params = JSON.parse(JSON.stringify(this.registertowParams.email))
      params = registerEncrypt(params)
      sendRegisterEmail(params)
        .then(() => {
          this.$message({
            type: 'success',
            message: 'Send successfully',
          })
          this.timeOut = 59
          this.countDown()
        })
        .catch(() => {
          this.timeOut = 0
        })
    },

    //验证验证码
    checkVerificationCode(registerTwoForm) {
      this.$refs[registerTwoForm].validate((valid) => {
        if (valid) {
          this.checkLoading = true
          let params = {}
          params.code = this.registerTwoForm.code
          params.email = registerEncrypt(
            JSON.parse(JSON.stringify(this.registertowParams.email))
          )
          checkRegisterEmail(params)
            .then(() => {
              this.checkLoading = false
              this.$emit('registerTwo', {
                code: this.registerTwoForm.code,
                isNext: true,
              })
            })
            .catch(() => {
              this.checkLoading = false
            })
        }
      })
    },
  },

  created() {
    let timeNum = this.$ls.get('reTimeOut')
    if (timeNum) {
      this.timeOut = timeNum
    }
    this.countDown()
  },
}
</script>

<style lang="scss" scoped>
.sp_step {
  .el-form {
    overflow-y: auto;
  }
  .el-form::-webkit-scrollbar {
    /*隐藏滚动条*/
    display: none;
  }
}
</style>